import ColorfulStepper from './colorful-stepper';
export default ColorfulStepper;
